import React, { useState, useEffect, createContext } from 'react'
import { useRouter } from 'next/router'

export const HistoryManagerContext = createContext([])

const HistoryManagerProvider = ({ children }) => {
  const [history, setHistory] = useState([])

  const router = useRouter()

  const { asPath } = router

  useEffect(() => {
    setHistory((prevHistory) => [...prevHistory, asPath])
  }, [])

  useEffect(() => {
    // if current route (`asPath`) is not same
    // add latest path to history array
    if (history[history.length - 1] !== asPath) {
      setHistory((prevHistory) => [...prevHistory, asPath])
    }
  })

  return (
    <HistoryManagerContext.Provider value={history}>
      {children}
    </HistoryManagerContext.Provider>
  )
}

export default HistoryManagerProvider
